import {
  setCellLink,
  setCellYear,
  setDateReceivedOrder,
  setPhoneFormat,
} from './ListClientsTable';

const columnsTable = [
  {
    header: 'User',
    accessorFn: (originalRow) => {
      return {
        id: originalRow['id'],
        notes: originalRow['AdminTextNoteClient'],
      };
    },
    id: 'id',
    cell: (info) => setCellLink(info.getValue()),
  },
  {
    header: 'Payment',
    id: 'payment',
    accessorKey: 'payment',
  },
  {
    header: 'Status',
    accessorFn: (originalRow) => String(originalRow['status'] || '--'),
    id: 'status',
  },
  {
    header: 'Admin Status',
    accessorFn: (originalRow) =>
      String(
        `${originalRow['AdminStatus'] || '--'}${
          originalRow['AdminStatus'] !== 'Completed' ? ' [1]' : ''
        }`,
      ),
    id: 'AdminStatus',
  },
  {
    header: 'Email',
    accessorFn: (originalRow) => String(originalRow.email || ''),
    id: 'email',
  },
  {
    header: 'SIN',
    accessorKey: 'sin',
    id: 'sin',
  },
  {
    header: 'First Name',
    accessorKey: 'firstName',
    id: 'firstName',
  },
  {
    header: 'Last Name',
    accessorKey: 'lastName',
    id: 'lastName',
  },
  {
    header: 'Phone',
    accessorKey: 'phone',
    Cell: setPhoneFormat,
    id: 'phone',
  },
  {
    header: 'Received Date',
    accessorKey: 'dateReceived',
    Cell: setDateReceivedOrder,
    id: 'dateReceived',
  },
  {
    header: 'Couple',
    accessorFn: (originalRow) =>
      originalRow.taxTogether === 'Yes' &&
      (originalRow.maritalStatus === 'Married' ||
        originalRow.maritalStatus === 'Common-Law')
        ? 'Yes'
        : 'No',
    id: 'taxTogether',
  },
  {
    header: 'Year',
    accessorKey: 'enrolmentYear',
    Cell: setCellYear,
    id: 'enrolmentYear',
  },
];
export default columnsTable;
